export const FETCH_SUBCOLLECTIONS_REQUEST = 'FETCH_SUBCOLLECTIONS_REQUEST';
export const FETCH_SUBCOLLECTIONS_SUCCESS = 'FETCH_SUBCOLLECTIONS_SUCCESS';
export const FETCH_SUBCOLLECTIONS_FAILURE = 'FETCH_SUBCOLLECTIONS_FAILURE';

export const ADD_SUBCOLLECTION_REQUEST = 'ADD_SUBCOLLECTION_REQUEST';
export const ADD_SUBCOLLECTION_SUCCESS = 'ADD_SUBCOLLECTION_SUCCESS';
export const ADD_SUBCOLLECTION_FAILURE = 'ADD_SUBCOLLECTION_FAILURE';

export const UPDATE_SUBCOLLECTION_REQUEST = 'UPDATE_SUBCOLLECTION_REQUEST';
export const UPDATE_SUBCOLLECTION_SUCCESS = 'UPDATE_SUBCOLLECTION_SUCCESS';
export const UPDATE_SUBCOLLECTION_FAILURE = 'UPDATE_SUBCOLLECTION_FAILURE';

export const DELETE_SUBCOLLECTION_REQUEST = 'DELETE_SUBCOLLECTION_REQUEST';
export const DELETE_SUBCOLLECTION_SUCCESS = 'DELETE_SUBCOLLECTION_SUCCESS';
export const DELETE_SUBCOLLECTION_FAILURE = 'DELETE_SUBCOLLECTION_FAILURE';

export const SET_SUBCOLLECTION_EDIT = 'SET_SUBCOLLECTION_EDIT';
export const CLEAR_SUBCOLLECTION_EDIT = 'CLEAR_SUBCOLLECTION_EDIT'; 